var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { cloneDeep } from "lodash-es";
import Component from 'vue-class-component';
import Vue from 'vue';
import { useDragGhost } from "../../../lib/designer/DragGhost";
import { DND_TYPE_LAYOUT, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import DEFAULT_COMPONENT_ICON from '../../assets/defaultComponentIcon.png';
import { Watch } from 'vue-property-decorator';
let AlternativeList = class AlternativeList extends Vue {
  constructor() {
    super(...arguments);
    this.loadedImages = 0;
  }
  get layouts() {
    var _this$value;
    return ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.layouts) || [];
  }
  get isSwitchMode() {
    return !this.dragTitle || !this.dragSource;
  }
  onLoadedImagesChange(val) {
    if (val === this.layouts.length) {
      this.$emit('loaded');
    }
  }
  handleDragStart(ev, value, entityParams) {
    if (!value || this.isSwitchMode) return;
    const cValue = cloneDeep(value);
    this.uc.completeLayout(cValue);
    const {
      dataTransfer
    } = ev;
    const dataPayload = JSON.stringify(cValue, null, 2);
    dataTransfer.setData('text/plain', dataPayload);
    dataTransfer.setData(DND_TYPE_LAYOUT, dataPayload);
    useDragGhost(ev, this.dragTitle || this.uc.getLayoutName(cValue));
    this.designer.setDragSource({
      ...this.dragSource,
      layout: cValue
    });
    const {
      editZoneState
    } = this.uc.designer;
    editZoneState.currentDraggingEntityFitDataParams = entityParams;
    this.$emit('dragstart', this);
  }
  async handleDragEnd() {
    var _this$designer, _this$designer2, _this$designer3, _this$value2;
    this.$emit('dragend', this);
    this.designer.setDragSource(null);
    // 把更换组件弹窗拉起
    await this.$nextTick();
    setTimeout(() => {
      const {
        editZoneState
      } = this.designer;
      editZoneState.currentDraggingEntityFitDataParams = void 0;
    }, 500);
    (_this$designer = this.designer) === null || _this$designer === void 0 || _this$designer.openCompAlternatesWindow({
      place: (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || (_this$designer2 = _this$designer2.activeCompInstance) === null || _this$designer2 === void 0 ? void 0 : _this$designer2.$el,
      compPath: (_this$designer3 = this.designer) === null || _this$designer3 === void 0 ? void 0 : _this$designer3.compPath,
      title: ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.name) || '未知组件',
      dataPath: this.dataPath,
      getAlternates: () => this.value
    });
  }
  async handleSwitchAlt(ev, value, entityParams) {
    var _this$designer4;
    const activeComp = (_this$designer4 = this.designer) === null || _this$designer4 === void 0 ? void 0 : _this$designer4.activeComp;
    if (!activeComp) return;
    this.$emit('switch', [{
      ...this.value,
      layout: value
    }, entityParams]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-alterComp-compList"
    }, [this.layouts.map(entity => {
      var _this$value3;
      return h("div", {
        "class": "fitcomp-entity",
        "on": {
          "dragstart": e => this.handleDragStart(e, entity.layout, entity.entityParams),
          "dragend": () => this.handleDragEnd(),
          "click": e => this.handleSwitchAlt(e, entity.layout, entity.entityParams)
        },
        "attrs": {
          "draggable": !this.isSwitchMode
        },
        "style": {
          cursor: this.isSwitchMode ? 'pointer' : 'grab'
        }
      }, [entity.preview ? [h("img", {
        "class": "fitcomp-entity-img",
        "attrs": {
          "src": entity.preview
        },
        "on": {
          "load": () => this.loadedImages += 1
        }
      }), h("b", {
        "class": "fitcomp-entity-title"
      }, [" ", entity.title, " "])] : [h("img", {
        "class": "fitcomp-entity-img ucd-settleComponent-itemIcon",
        "attrs": {
          "src": ((_this$value3 = this.value) === null || _this$value3 === void 0 ? void 0 : _this$value3.icon) || DEFAULT_COMPONENT_ICON
        }
      }), h("b", {
        "class": "fitcomp-entity-title"
      }, [" ", entity.title, " "])]]);
    })]);
  }
};
__decorate([Watch('loadedImages')], AlternativeList.prototype, "onLoadedImagesChange", null);
AlternativeList = __decorate([Component({
  name: 'AlternativeList',
  props: {
    dataPath: String,
    value: {
      required: false,
      type: Object
    },
    dragTitle: String,
    dragSource: Object
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], AlternativeList);
export default AlternativeList;
//# sourceMappingURL=Alternates.js.map
